var _defs, _metadata, _rect, _g, _path, _g2, _path2, _g3, _circle, _g4, _circle2, _circle3, _circle4, _circle5, _polygon, _path3, _path4, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAni16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "77.2523mm",
    height: "62.5082mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 2154 1743",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .str1 {stroke:black;stroke-width:49.1878}\r\n    .str0 {stroke:black;stroke-width:49.1878}\r\n    .str2 {stroke:black;stroke-width:49.1878;stroke-linecap:round}\r\n    .str3 {stroke:black;stroke-width:49.1878;stroke-linecap:round;stroke-linejoin:round}\r\n    .fil0 {fill:none}\r\n    .fil6 {fill:black}\r\n    .fil1 {fill:#FF6633}\r\n    .fil2 {fill:#FFB39A}\r\n    .fil4 {fill:white}\r\n    .fil5 {fill:white;fill-rule:nonzero}\r\n    .fil3 {fill:white;fill-opacity:0.501961}\r\n  "), /*#__PURE__*/React.createElement("clipPath", {
    id: "id0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1077 325c-69,-1 -469,14 -699,510 -279,599 242,674 699,673 457,0 978,-73 699,-673 -230,-496 -630,-511 -699,-510z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Capa_x0020_1"
  }, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_557012616"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "fil0",
    width: 2154,
    height: 1743
  })), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M530 692c0,0 -156,-144 -64,-281 92,-137 161,-156 184,-294 23,-138 55,314 43,418 -11,104 -163,157 -163,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M608 560l5 -220c0,0 -34,80 -84,117 -51,37 -43,118 11,152 55,33 68,-49 68,-49z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil1 str0",
    d: "M1625 692c0,0 156,-144 64,-281 -92,-137 -162,-156 -185,-294 -23,-138 -54,314 -43,418 12,104 164,157 164,157z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil2",
    d: "M1546 560l-5 -220c0,0 34,80 84,117 51,37 44,118 -11,152 -54,33 -68,-49 -68,-49z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M1077 325c-69,-1 -469,14 -699,510 -279,599 242,674 699,673 457,0 978,-73 699,-673 -230,-496 -630,-511 -699,-510z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#id0)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil3",
    d: "M1478 1475c192,-57 301,-149 305,-255 2,-62 -59,-87 -151,-86l0 0c150,-352 -353,-547 -458,-153 -23,87 14,202 70,252l0 0c-91,41 -153,86 -167,135 -15,-49 -77,-94 -168,-135l0 0c56,-50 93,-165 70,-252 -105,-394 -608,-199 -458,153l0 0c-91,-1 -152,24 -150,86 3,106 112,198 304,255 6,2 203,54 402,54 197,0 395,-52 401,-54z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "fil4",
    cx: 1077,
    cy: 1370,
    rx: 269,
    ry: 225
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str1",
    d: "M1077 325c-69,-1 -469,14 -699,510 -279,599 242,674 699,673 457,0 978,-73 699,-673 -230,-496 -630,-511 -699,-510z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M949 1012l-98 0 0 0 0 -4 0 -5 -1 -4 -1 -4 -1 -4 -1 -5 -1 -3 -1 -4 -2 -4 -1 -4 -2 -3 -2 -4 -2 -3 -3 -3 -2 -3 -2 -3 -3 -2 -3 -3 -2 -2 -3 -2 -3 -2 -3 -2 -3 -2 -3 -1 -3 -2 -3 -1 -3 -1 -3 -1 -4 0 -3 -1 -3 0 -4 0 0 -99 9 1 9 0 8 2 9 1 8 2 8 3 8 3 8 3 8 4 7 4 7 5 7 4 7 6 6 5 6 6 6 6 5 6 6 7 5 7 4 7 4 7 4 8 4 7 3 8 3 8 3 9 2 8 2 9 1 8 1 9 1 9 0 9 0 0zm-169 181l0 -98 0 0 4 -1 3 0 3 0 4 -1 3 -1 3 -1 3 -1 3 -1 3 -2 3 -1 3 -2 3 -2 3 -2 2 -3 3 -2 3 -3 2 -3 2 -3 3 -3 2 -3 2 -4 2 -3 1 -4 2 -3 1 -4 1 -4 1 -4 1 -4 1 -5 1 -4 0 -4 0 -5 98 0 0 9 -1 9 -1 9 -1 9 -2 8 -2 9 -3 8 -3 8 -3 8 -4 8 -4 7 -4 8 -4 7 -5 6 -6 7 -5 6 -6 6 -6 6 -6 6 -7 5 -7 5 -7 4 -7 4 -8 4 -8 3 -8 3 -8 3 -8 2 -9 2 -8 1 -9 1 -9 0 0 0zm-169 -181l98 0 0 0 0 5 1 4 0 4 1 5 1 4 1 4 1 4 1 4 2 3 2 4 1 3 2 4 2 3 3 3 2 3 2 3 3 3 3 2 2 3 3 2 3 2 3 2 3 1 3 2 3 1 3 1 3 1 4 1 3 1 3 0 4 0 3 1 0 98 -9 0 -9 -1 -8 -1 -9 -2 -8 -2 -8 -3 -8 -3 -8 -3 -8 -4 -7 -4 -7 -4 -7 -5 -7 -5 -6 -6 -6 -6 -6 -6 -5 -6 -6 -7 -4 -6 -5 -7 -4 -8 -4 -7 -4 -8 -3 -8 -3 -8 -3 -8 -2 -9 -2 -8 -1 -9 -1 -9 -1 -9 0 -9 0 0zm169 -181l0 99 0 0 -3 0 -4 0 -3 1 -3 0 -4 1 -3 1 -3 1 -3 2 -3 1 -3 2 -3 2 -3 2 -3 2 -2 2 -3 3 -3 2 -2 3 -2 3 -3 3 -2 3 -2 4 -1 3 -2 4 -2 4 -1 4 -1 3 -1 5 -1 4 -1 4 0 4 -1 5 0 4 -98 0 0 -9 1 -9 1 -9 1 -8 2 -9 2 -8 3 -9 3 -8 3 -8 4 -7 4 -8 4 -7 5 -7 4 -7 6 -7 5 -6 6 -6 6 -6 6 -5 7 -6 7 -4 7 -5 7 -4 8 -4 8 -3 8 -3 8 -3 8 -2 9 -1 8 -2 9 0 9 -1 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil4",
    d: "M780 881c66,0 120,58 120,131 0,73 -54,132 -120,132 -66,0 -120,-59 -120,-132 0,-73 54,-131 120,-131z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "fil6",
    cx: 813,
    cy: 1014,
    r: 109
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil5",
    d: "M1205 1012l0 0 1 -9 0 -9 1 -9 2 -8 2 -9 2 -8 2 -9 3 -8 3 -8 4 -7 4 -8 4 -7 5 -7 5 -7 5 -7 5 -6 6 -6 6 -6 7 -5 6 -6 7 -4 7 -5 7 -4 8 -4 8 -3 8 -3 8 -3 8 -2 9 -1 9 -2 8 0 9 -1 0 99 -3 0 -4 0 -3 1 -3 0 -3 1 -4 1 -3 1 -3 2 -3 1 -3 2 -3 2 -3 2 -2 2 -3 2 -3 3 -2 2 -3 3 -2 3 -2 3 -2 3 -2 4 -2 3 -2 4 -1 4 -2 4 -1 3 -1 5 -1 4 -1 4 0 4 0 5 -1 4 0 0 -98 0zm169 181l0 0 -9 0 -8 -1 -9 -1 -9 -2 -8 -2 -8 -3 -8 -3 -8 -3 -8 -4 -7 -4 -7 -4 -7 -5 -6 -5 -7 -6 -6 -6 -6 -6 -5 -6 -5 -7 -5 -6 -5 -7 -4 -8 -4 -7 -4 -8 -3 -8 -3 -8 -2 -8 -2 -9 -2 -8 -2 -9 -1 -9 0 -9 -1 -9 98 0 1 5 0 4 0 4 1 5 1 4 1 4 1 4 2 4 1 3 2 4 2 3 2 4 2 3 2 3 2 3 3 3 2 3 3 2 3 3 2 2 3 2 3 2 3 1 3 2 3 1 3 1 4 1 3 1 3 1 3 0 4 0 3 1 0 0 0 98zm169 -181l0 0 0 9 -1 9 -1 9 -1 9 -2 8 -2 9 -3 8 -3 8 -3 8 -3 8 -4 7 -5 8 -4 7 -5 6 -5 7 -6 6 -6 6 -6 6 -6 6 -7 5 -6 5 -8 4 -7 4 -7 4 -8 3 -8 3 -8 3 -9 2 -8 2 -9 1 -9 1 -9 0 0 -98 4 -1 3 0 3 0 4 -1 3 -1 3 -1 3 -1 3 -1 3 -2 3 -1 3 -2 3 -2 3 -2 3 -3 2 -2 3 -3 2 -3 3 -3 2 -3 2 -3 2 -4 2 -3 2 -4 1 -3 1 -4 2 -4 1 -4 1 -4 0 -5 1 -4 0 -4 0 -5 0 0 98 0zm-169 -181l0 0 9 1 9 0 9 2 8 1 9 2 8 3 8 3 8 3 7 4 7 4 8 5 6 4 7 6 6 5 6 6 6 6 6 6 5 7 5 7 4 7 5 7 4 8 3 7 3 8 3 8 3 9 2 8 2 9 1 8 1 9 1 9 0 9 -98 0 0 -4 0 -5 -1 -4 0 -4 -1 -4 -1 -5 -2 -3 -1 -4 -1 -4 -2 -4 -2 -3 -2 -4 -2 -3 -2 -3 -3 -3 -2 -3 -3 -2 -2 -3 -3 -2 -3 -2 -3 -2 -3 -2 -3 -2 -3 -1 -3 -2 -3 -1 -3 -1 -3 -1 -4 0 -3 -1 -3 0 -4 0 0 0 0 -99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: 1,
    className: "fil4",
    d: "M1374 881c-66,0 -120,58 -120,131 0,73 54,132 120,132 67,0 120,-59 120,-132 0,-73 -53,-131 -120,-131z"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "fil6",
    cx: 1341,
    cy: 1014,
    r: 109
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 1309,
    cy: 1013,
    r: 43
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "fil4",
    cx: 846,
    cy: 1013,
    r: 43
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "fil6",
    cx: 1077,
    cy: 1276,
    r: 78
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "fil4",
    points: "1151,1418 1151,1536 1003,1536 1003,1418 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str2",
    d: "M1077 1276c0,35 2,71 0,106 -4,52 -119,60 -126,-34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "fil0 str2",
    d: "M1078 1276c0,35 -3,71 0,106 4,52 118,60 125,-34"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "fil0 str3",
    points: "1151,1418 1151,1536 1003,1536 1003,1418 "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni16);
export default __webpack_public_path__ + "static/media/ani16.9742af036f1af3ec035248bb4039e2ba.svg";
export { ForwardRef as ReactComponent };